import styled from "styled-components";
import { media } from "utils/style-utils";

export const Tabs = styled.nav`
  ${media.touch`
    ul {
      display: flex !important;
      flex-flow: column nowrap !important;
      align-items: stretch;
    }
    li {
      width: 100%;
    }
    a {
      border-radius: 5px !important;
    }
    li:not(:last-child) {
      margin-bottom: .5rem !important;
    }
  `};
`;

export const StyledLI = styled.li`
  &.is-active {
    a {
      background-color: #c93e4e !important;
      border-color: #c93e4e !important;
    }
  }
  a {
    text-decoration: none !important;
  }
`;

export const MaterialSection = styled.div`
  background-image: url('${props => props.background}');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
`;

export const ElementWrapper = styled.div`
  position: relative;
  width: 75px;
  height: 100px;
  margin: 0.5em;
  background-color: transparent;
  font-family: "Helvetica", sans-serif;
  font-weight: 600;
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-top: 1em;
  padding: 1em auto auto;
`;

export const ElementWrapperInner = styled.div`
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 1px;
  left: 0;
  border: 1px solid ${props => props.theme.color};
  text-align: center;
  cursor: default;
  box-sizing: border-box;
  pointer-events: none;
`;

export const ElementName = styled.div`
  position: absolute;
  color: ${props => props.theme.color};
  opacity: 100;
  right: 0;
  left: 0;
  bottom: 15px;
  font-size: 0.7em;
`;

export const ElementNumber = styled.div`
  position: absolute;
  color: ${props => props.theme.color};
  opacity: 100;
  top: 5px;
  right: 6px;
  font-size: 0.8em;
`;
export const ElementSymbol = styled.div`
  position: absolute;
  top: 35%;
  right: 0;
  left: 0;
  margin-top: -5px;
  color: ${props => props.theme.color};
  font-size: 1.8em;
  line-height: 1.2;
  content: "";
`;
export const ElementWeight = styled.div`
  position: absolute;
  color: ${props => props.theme.color};
  opacity: 100;
  right: 0;
  left: 0;
  content: "";
  bottom: 4px;
  font-size: 0.5em;
`;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/styled.js